'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var formatDate = require('./formatDate.js');

function getIanaTimeZone(locale, options) {
  return formatDate.memoizedGetDateTimeFormat(locale, options).resolvedOptions().timeZone;
}

exports.getIanaTimeZone = getIanaTimeZone;
